import { render, staticRenderFns } from "./MianZeTiaoKuanView.vue?vue&type=template&id=469753c1&scoped=true"
import script from "./MianZeTiaoKuanView.vue?vue&type=script&lang=js"
export * from "./MianZeTiaoKuanView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469753c1",
  null
  
)

export default component.exports